import { API_ENDPOINTS, API_ERROR_MESSAGES } from "../constants/api";
import { apiFetch } from "./apiClient";

export class ApiError extends Error {
  constructor(message, details = {}) {
    super(message);
    this.name = "ApiError";
    this.details = details;
  }
}

export async function fetchInboundMetadata() {
  const response = await apiFetch(API_ENDPOINTS.inbound.metadata);

  let result;

  try {
    result = await response.json();
  } catch {
    throw new Error(API_ERROR_MESSAGES.inboundMetadataReadFailed);
  }

  if (!response.ok || !result.success) {
    throw new Error(
      result?.message || API_ERROR_MESSAGES.inboundMetadataFetchFailed,
    );
  }

  return result.data;
}

export async function fetchInboundHistory(phoneNumber) {
  const response = await apiFetch(API_ENDPOINTS.inbound.history, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ phone_number: phoneNumber }),
  });

  let result;

  try {
    result = await response.json();
  } catch {
    throw new Error(API_ERROR_MESSAGES.inboundHistoryReadFailed);
  }

  if (!response.ok || !result.success) {
    throw new Error(
      result?.message || API_ERROR_MESSAGES.inboundHistoryFetchFailed,
    );
  }

  return result;
}

export async function saveInboundEntry(entry) {
  const response = await apiFetch(API_ENDPOINTS.inbound.entries, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(entry),
  });

  let result;

  try {
    result = await response.json();
  } catch {
    throw new Error(API_ERROR_MESSAGES.inboundEntryReadFailed);
  }

  if (!response.ok) {
    throw new ApiError(
      result?.message || API_ERROR_MESSAGES.inboundEntrySaveFailed,
      result,
    );
  }

  return result;
}

export async function assignInboundUrgent({ phoneNumber, name }) {
  const response = await apiFetch(API_ENDPOINTS.inbound.assignUrgent, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      phone_number: phoneNumber,
      name,
    }),
  });

  let result;

  try {
    result = await response.json();
  } catch {
    throw new Error(API_ERROR_MESSAGES.inboundUrgentReadFailed);
  }

  if (!response.ok || !result.success || !result.assigned) {
    throw new ApiError(
      result?.message || API_ERROR_MESSAGES.inboundUrgentAssignFailed,
      result,
    );
  }

  return result;
}
